import React from 'react';

import useStoreTranslation from 'hooks/useStoreTranslation';

import { Valid, Invalid, Container } from './styles';

interface Props {
  isPreApproved: boolean;
  breakRules: string[];
}

const PolicyTag = ({ isPreApproved, breakRules }: Props) => {
  const { t } = useStoreTranslation();
  return (
    <Container>
      {!isPreApproved && breakRules && breakRules.length > 0 ? (
        <Invalid>{t('hotelFlightsTags.invalid')}</Invalid>
      ) : (
        <Valid>{t('hotelFlightsTags.valid')}</Valid>
      )}
    </Container>
  );
};
export default PolicyTag;
